/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { ImageHelper } from "@nf/common";
import { RouteHelper } from "helpers/routeHelper";

import AppImage from "components/AppImage";
import LinkWithLocale from "components/LinkWithLocale";
import MediaAdditionalInfo from "components/Media/MediaAdditionalInfo";
import MoreInfoButton from "components/MoreInfoButton";
import MyListButton from "components/MyListButton";
import PlayButton from "components/PlayButton";
import { useSyncCompleted } from "hooks";

import type { IListComponentItemProps } from "../../models";

import styles from "./ListComponentItemPromo.module.scss";

export const ListComponentItemPromo = ({ media }: IListComponentItemProps) => {
  const isAuthProcessCompleted = useSyncCompleted();

  if (!media) {
    return null;
  }

  return (
    <div className={styles.item}>
      <LinkWithLocale href={RouteHelper.goToDetails(media)}>
        <a className={styles.imageLink}>
          <div className={styles.imageContainer}>
            <AppImage
              src={
                ImageHelper.getHighlightAssetFrontpagelUrl(media.Images) || ""
              }
              alt={media.Title || ""}
              className={styles.image}
            />
          </div>
        </a>
      </LinkWithLocale>

      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.header}>{media.Description}</h1>

          <h2 className={styles.title}>{media.Title}</h2>

          <MediaAdditionalInfo
            type={media.MediaTypeCode}
            year={media.Year}
            categories={media.Categories}
            className={styles.metadata}
          />

          <p className={styles.description}>
            {media?.ShortDescription || media?.LongDescription || ""}
          </p>

          {isAuthProcessCompleted && (
            <div className={styles.actions}>
              <PlayButton media={media} />

              <MoreInfoButton media={media} />

              <MyListButton media={media} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
